module.exports = __webpack_public_path__ + "static/media/u45_premium_contract6.5840685c.webp";